import React from 'react';
import { FilterSecondaryBadge } from './FiltersSecondary.style';
import { FilterSecondary, FilterSecondaryPropsType } from './FilterSecondary';

interface FilterSecondaryWithBadgePropsType extends FilterSecondaryPropsType {
    badge: React.ReactNode;
}

export const FilterSecondaryWithBadge = ({
    badge,
    children,
    isActive,
    ...rest
}: FilterSecondaryWithBadgePropsType): JSX.Element => {
    return (
        <FilterSecondary
            isActive={isActive}
            filterType='badge'
            {...rest}
        >
            {children}
            <FilterSecondaryBadge isActive={isActive}>{badge}</FilterSecondaryBadge>
        </FilterSecondary>
    );
};
